/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { ROOT_SLICE } from '../constants';

const {
  setReportCounts,
  setToggleState,
	setRefReportAggs,
  clear, // destroys state, replacing with initial state
} = createActions(
	{
    SET_REPORT_COUNTS: ({ countExistingReports, countGhostReports }) => ({ countExistingReports, countGhostReports }),
    SET_TOGGLE_STATE: (toggleState) => ({ toggleState }),
		SET_REF_REPORT_AGGS: (reportAggs) => ({ reportAggs }),
    CLEAR: () => ({})
	},
	{ prefix: ROOT_SLICE }
);

export { setReportCounts, setToggleState, setRefReportAggs, clear };

export default { setReportCounts, setToggleState, setRefReportAggs, clear };
